<ul>
  <li *ngIf="item.file" class="download-item">
    <button (click)="goToAction(item.file)" class="btn btn-primary">{{ actionLabel }}</button>
  </li>
  <li *ngIf="item.secondary_file" class="download-item">
    <button (click)="goToAction(item.secondary_file)" class="btn btn-primary">{{ actionBackLabel }}</button>
  </li>
</ul>
